import { Controller } from "@hotwired/stimulus"

// The estimator looks the listing up live, which takes a few seconds. On submit, swap the old result for a loading
// panel and lock the button so the visitor sees progress (and cannot fire a second lookup) until the new page arrives.
export default class extends Controller {
  static targets = ["button", "loader", "result"]

  connect() {
    // Coming back with the browser's Back button can restore the page frozen in its loading state.
    this.reset = () => this.#setLoading(false)
    window.addEventListener("pageshow", this.reset)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.reset)
  }

  start() {
    this.#setLoading(true)
  }

  #setLoading(loading) {
    this.loaderTarget.hidden = !loading
    this.buttonTarget.disabled = loading
    this.element.setAttribute("aria-busy", loading)
    this.resultTargets.forEach((el) => { el.hidden = loading })
    if (loading) this.loaderTarget.scrollIntoView({ block: "nearest", behavior: "smooth" })
  }
}
